import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Reveal, ChapterTag } from "@/components/Reveal";

const FAQS = [
  {
    q: "What is Peanut Valet?",
    a: "Peanut Valet is a hand-crank peanut sheller in development, designed around a top hopper and separate collection drawers for peanuts and shells.",
  },
  {
    q: "Can I buy one now?",
    a: "Peanut Valet is still in development. Join the update list to hear about progress and future availability.",
  },
  {
    q: "Does it need electricity?",
    a: "The design shown uses a hand crank rather than an electric motor.",
  },
  {
    q: "Are these photographs of a finished product?",
    a: "The product images and video are rendered illustrations of the design and intended experience.",
  },
  {
    q: "How can I support the project?",
    a: "Join our update list and share Peanut Valet with someone who would enjoy following the journey. We'll announce fundraising opportunities when they are ready.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="scroll-mt-24 bg-[#F7F1E6] py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal>
          <ChapterTag number="06" label="Questions" />
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 text-[1.9rem] font-extrabold leading-tight tracking-tight text-[#074345] sm:text-4xl lg:text-[2.6rem]">
            Frequently asked questions
          </h2>
        </Reveal>

        <Reveal delay={0.12} className="mt-10">
          <div className="border-t border-[#EADCC6]">
            {FAQS.map((f, i) => (
              <div key={f.q} data-testid={`faq-item-${i + 1}`} className="border-b border-[#EADCC6]">
                <button
                  type="button"
                  data-testid={`faq-question-${i + 1}`}
                  aria-expanded={open === i}
                  aria-controls={`faq-panel-${i}`}
                  id={`faq-button-${i}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 py-6 text-left"
                >
                  <span className="text-lg font-extrabold text-[#074345]">{f.q}</span>
                  <ChevronDown
                    className={`h-5 w-5 shrink-0 text-[#F3802A] transition-transform duration-300 ${open === i ? "rotate-180" : ""}`}
                    aria-hidden="true"
                  />
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                      id={`faq-panel-${i}`}
                      role="region"
                      aria-labelledby={`faq-button-${i}`}
                    >
                      <p data-testid={`faq-answer-${i + 1}`} className="max-w-2xl pb-6 text-base leading-relaxed text-[#243C39]">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
